module.exports = "../study/imgs/maps/Kanagawa/S8/Agriculture/Rice/Kanagawa_Rice_MIROC5_RCP26_Mid.png";